/* eslint-disable  import/prefer-default-export */
const DATA_TESTID_SUFFIXES = {
  MENU_PANE: 'menupane',
  MENU_ITEM: 'menuitem',
  MENU_BUTTON: 'menubutton',
  MENU_SEARCH: 'menusearch',
  MENU_BACK: 'menuback'
};
const KEYS = {
  OPEN_SUBMENU: ['ArrowRight', 'Enter'],
  CLOSE_SUBMENU: ['ArrowLeft'],
  NAVIGATE_UP: ['ArrowUp'],
  NAVIGATE_DOWN: ['ArrowDown'],
  NAVIGATE_TOP: ['Home'],
  NAVIIGATE_BOTTOM: ['End'],
  IGNORED_BY_SEARCH_INPUT: ['Tab']
};
const VIRTUOSO_PROPS = {
  increaseViewportBy: 250
};

export { DATA_TESTID_SUFFIXES, KEYS, VIRTUOSO_PROPS };
